import { Box, Typography, useTheme } from "@mui/material";
import React, { useState } from "react";
import Boxoutline from "../../../../../../media/images/icons/outline-box";
import LocationFill from "../../../../../../media/images/icons/location-fill";
import ArrowStepLeft from "../../../../../../media/images/icons/arrow-steps-register";
import { IorderInfo } from "../../ActiveFeright";
import { addCommas } from "@persian-tools/persian-tools";
import CustomButton from "../../../../../components/CustomButton";
import ArrowTickLeft from "../../../../../../media/images/icons/arrow-tick-left";
import StarFillSVG from "../../../../../../media/images/icons/star-fill";
import GiveScoreBottomSheet from "./GiveScoreBottomSheet";
import BarDetailsBottomSheet from "./BarDetailsBottomSheet";
import { INobatHistory } from "..";

export default function CompleteCargoCard(props: INobatHistory) {
  const { goodsName, cityName, destination, id, bolNumber } = props;
  const theme = useTheme();

  const [scorebottomSheetStep, setScoreBottomSheetStep] = useState(0);

  const [barDetailsBottomSheet, setBarDetailsBottomSheet] = useState(false);

  const [orderInfo, setOrderInfo] = useState<IorderInfo>({
    id: "",
    companyName: "",
    registrarsInfo: {
      insertDateTime: "",
    },
    goodsInfo: {
      name: "انواع قطعات ماشین آلات سنگین",
    },
    truckWeightTo: "500",
    description: "",
    packageTypeInfo: {
      name: "پالت",
    },
    goodsCost: "20000000",
    senderAddress: {
      cityName: "تهران",
      address: "",
    },
    receiverAddress: {
      cityName: "یزد",
    },
  } as IorderInfo);
  return (
    <>
      <GiveScoreBottomSheet
        setStep={setScoreBottomSheetStep}
        step={scorebottomSheetStep}
        barId={id}
      />
      <BarDetailsBottomSheet
        onDismiss={() => setBarDetailsBottomSheet(false)}
        open={barDetailsBottomSheet}
      />
      <Box
        sx={{
          padding: "8px",
          borderColor: "bgColor.blueGrey100",
          borderWidth: "1px",
          borderStyle: "solid",
          borderRadius: "16px",
          backgroundColor: "bgColor.white",
        }}
      >
        <Typography
          sx={{
            fontSize: "14px",
            textAlign: "center",
            color: "success.main",
          }}
        >
          بارنامه شده
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Box
            sx={{
              display: "flex",
              gap: "8px",
              width: "100%",
            }}
          >
            <Box
              sx={{
                backgroundColor: theme.palette.bgColor.blueGrey100,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "6px",
                borderRadius: "8px",
              }}
            >
              <Boxoutline color={theme.palette.textColor.main} />
            </Box>
            <Box
              sx={{
                flex: 1,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  sx={{
                    fontWeight: "700",
                    fontSize: "14px",
                  }}
                >
                  شماره بارنامه:
                </Typography>
                <Typography
                  sx={{
                    fontSize: "14px",
                  }}
                >
                  {bolNumber}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: "700",
                  }}
                >
                  نام محموله:
                </Typography>
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: "600",
                  }}
                >
                  {goodsName}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: "700",
                  }}
                >
                  کرایه:
                </Typography>
                <Typography
                  sx={{
                    fontSize: "14px",
                  }}
                  noWrap
                >
                  {addCommas(orderInfo?.goodsCost!)}
                  ریال
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: "700",
                  }}
                >
                  تناژ / بسته‌بندی:
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                  }}
                >
                  <Typography noWrap variant="body2">
                    {orderInfo?.truckWeightTo} تن
                  </Typography>
                  /
                  <Typography noWrap variant="body2">
                    {orderInfo?.packageTypeInfo?.name!}
                  </Typography>
                </Box>
              </Box>
              {/* <Box
                sx={{
                  display: "flex",
                }}
              >
                <Box
                  sx={{
                    width: "fit-content",
                    borderColor: "info.main",
                    borderWidth: "1px",
                    borderStyle: "solid",
                    backgroundColor: "background.default",
                    padding: "2px",
                    borderRadius: "6px",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "14px",
                    }}
                    noWrap
                  >
                    {addCommas(orderInfo?.goodsCost!)}
                    ریال
                  </Typography>
                </Box>
                <Box
                  sx={{
                    borderColor: "info.main",
                    borderWidth: "1px",
                    borderStyle: "solid",
                    width: "fit-content",
                    backgroundColor: "background.default",
                    padding: "2px",
                    borderRadius: "6px",
                  }}
                >
                  <Typography noWrap variant="body2">
                    {orderInfo?.truckWeightTo} تن
                  </Typography>
                </Box>
              </Box> */}
            </Box>
            {/* <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                flexDirection: "column",
              }}
            >
              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: "700",
                }}
              >
                {goodsName}
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography variant="body2" sx={{}}>
                  وضعیت:
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "success.main",
                  }}
                >
                  بارنامه صادرشده
                </Typography>
              </Box>
            </Box> */}
          </Box>
          {/* <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              flexWrap: "wrap",
              gap: "4px",
              justifyContent: "end",
            }}
          >
            <Box
              sx={{
                borderColor: "info.main",
                borderWidth: "1px",
                borderStyle: "solid",
                backgroundColor: "background.default",
                padding: "2px",
                borderRadius: "6px",
              }}
            >
              <Typography
                sx={{
                  fontSize: "14px",
                }}
                noWrap
              >
                {addCommas(orderInfo?.goodsCost!)}
                ریال
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                gap: "4px",
                justifyContent: "end",
              }}
            >
              <Box
                sx={{
                  borderColor: "info.main",
                  borderWidth: "1px",
                  borderStyle: "solid",
                  backgroundColor: "background.default",
                  padding: "2px",
                  borderRadius: "6px",
                }}
              >
                <Typography noWrap variant="body2">
                  {orderInfo?.truckWeightTo} تن
                </Typography>
              </Box>
              <Box
                sx={{
                  borderColor: "info.main",
                  borderWidth: "1px",
                  borderStyle: "solid",
                  backgroundColor: "background.default",
                  padding: "2px",
                  borderRadius: "6px",
                }}
              >
                <Typography noWrap variant="body2">
                  {orderInfo?.packageTypeInfo.name!}
                </Typography>
              </Box>
            </Box>
          </Box> */}
        </Box>
        <Box
          sx={{
            mt: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-evenly",
            backgroundColor: "background.default",
            padding: "8px",
            borderRadius: "8px",
            borderColor: "info.main",
            borderWidth: "1px",
            borderStyle: "solid",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flex: 1,
              justifyContent: "center",
            }}
          >
            <LocationFill color={theme.palette.primary.main} />
            <Typography
              variant="body2"
              sx={{
                color: "primary.main",
              }}
            >
              {cityName}
            </Typography>
          </Box>
          <ArrowStepLeft color={theme.palette.textColor.main} />
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flex: 1,
              justifyContent: "center",
            }}
          >
            <LocationFill color={theme.palette.secondary.main} />
            <Typography
              variant="body2"
              sx={{
                color: "secondary.main",
              }}
            >
              {destination}
            </Typography>
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            mt: 1,
            gap: "8px",
          }}
        >
          <CustomButton
            onClick={() => setScoreBottomSheetStep(2)}
            flex={1}
            justifyContent="center"
            title="نظرسنجی بار"
            bgColor="secondary.main"
            fSize="14px"
            px="6px"
            py="8px"
            borderRadius="6px"
            icon1={<StarFillSVG size={22} color={"#fff"} />}
          />
          <CustomButton
            onClick={() => setBarDetailsBottomSheet(true)}
            flex={1}
            justifyContent="center"
            title="مشاهده جزئیات بار"
            bgColor="success.main"
            fSize="14px"
            px="6px"
            py="8px"
            borderRadius="6px"
            // icon2={<ArrowTickLeft size={18} color={"#fff"} />}
          />
        </Box>
      </Box>
    </>
  );
}
